import React from 'react';
import Container from '@mui/material/Container';
import { useDispatch, useSelector } from 'react-redux';
import StatisticsEncouragementMessageForm
  from '../../../components/forms/StatisticsEncouragementMessageForm';
import PageCircularProgress from '../../../components/PageCircularProgress/PageCircularProgress';
import {
  getStatisticsEncouragementMessages,
} from '../../../store/statisticsEncouragementMessage/action';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { useUserAuth } from '../../../contexts/UserAuthContext.js';

export default function AddStatisticsEncouragementMessagePage() {
  const {
    pending,
    content,
    error,
  } = useSelector((state) => state.statisticsEncouragementMessage);
  const dispatch = useDispatch();
  const { token } = useUserAuth();

  if (!content && !pending && !error) {
    dispatch(getStatisticsEncouragementMessages(token));
  }

  return (
    <Container maxWidth={false}>
      <PageTitle title="Ajouter un encouragement de suivi" />
      {(
        pending || content === null
      ) && <PageCircularProgress />}
      {content !== null
        && (
          <StatisticsEncouragementMessageForm />
        )}
    </Container>
  );
}
